import { NgModule } from '@angular/core';
import { Routes, RouterModule, NoPreloading } from '@angular/router';
import { LayoutComponent } from '@app/layouts/components/layout.component';
import { ErrorPageComponent } from '@app/layouts/components/error-page.component';
import { TgWebAppStartParamMatcher, BookmakersMatcher, MainMatcher, StreamMatcher } from './url.matchers';


const routes: Routes = [

    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                matcher: TgWebAppStartParamMatcher('live'),
                redirectTo: '/live',
            },
            {
                matcher: TgWebAppStartParamMatcher('soon'),
                redirectTo: '/soon',
            },
            {
                matcher: TgWebAppStartParamMatcher('wait'),
                redirectTo: '/wait',
            },
            {
                matcher: TgWebAppStartParamMatcher('bookmakers'),
                redirectTo: '/bookmakers',
            },
            {
                matcher: MainMatcher,
                loadChildren: () => import('./main/main.module').then(m => m.MainModule),
            },
            {
                matcher: StreamMatcher,
                loadChildren: () => import('./stream/stream.module').then(m => m.StreamModule),
            },
            {
                matcher: BookmakersMatcher,
                loadChildren: () => import('./bookmakers/bookmakers.module').then(m => m.BookmakersModule),
            },
            {
                path: '**',
                component: ErrorPageComponent,
            }
        ],

    },

];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        preloadingStrategy: NoPreloading,
        scrollPositionRestoration: 'enabled',
        initialNavigation: 'enabledNonBlocking',
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
